import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import PushNotificationTemplateEdit from './PushNotificationTemplateEdit';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';
import { slugToType } from '../pushNotificationTemplates/pushNotificationTemplateSlug';

export default async function action({ store, params, intl }) {
  const typeParam = params?.type ? decodeURIComponent(params.type) : '';
  const type = slugToType(typeParam);
  const locale = params?.locale ? decodeURIComponent(params.locale) : '';
  const title = intl?.formatMessage(messages.managePushNotificationTemplates);

  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;


  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!type) {
    return { redirect: '/siteadmin/push-notification-templates' };
  }

  if (!restrictUrls('/siteadmin/push-notification-templates', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <PushNotificationTemplateEdit type={type} locale={locale} />
      </AdminLayout>
    ),
  };
}
